import { motion, useReducedMotion } from "framer-motion";

export const Book3D = ({ title, category, pages, accent = "bg-ink", small = false }) => {
  const reduce = useReducedMotion();
  return (
    <div className="group [perspective:1200px] select-none inline-block" data-testid="book-3d">
      <motion.div
        animate={reduce ? {} : { y: [0, -10, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        className={`relative ${small ? "w-40 sm:w-48" : "w-52 sm:w-64"} aspect-[5/7] [transform-style:preserve-3d] transition-transform duration-700 ease-out group-hover:[transform:rotateY(-18deg)_scale(1.03)]`}
      >
        <div className="absolute inset-0 bg-[#FFFDF7] border border-ink/10 shadow-[10px_14px_34px_rgba(13,27,42,0.2)]">
          <div className="absolute top-5 left-6 font-mono2 text-[10px] tracking-[0.2em] text-ink/40 uppercase">Κεφ. 01</div>
          <div className="absolute inset-x-6 top-12 bottom-6 space-y-3 pt-2">
            {[...Array(9)].map((_, i) => (
              <div key={i} className="h-px bg-ink/15" style={{ width: `${88 - (i % 4) * 9}%` }} />
            ))}
          </div>
        </div>
        <div
          className={`absolute inset-0 origin-left transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:[transform:rotateY(-30deg)] ${accent} text-cream shadow-[2px_2px_0_rgba(13,27,42,0.35)]`}
        >
          <div className="absolute left-0 top-0 bottom-0 w-2 bg-black/25" />
          <div className={`absolute inset-0 flex flex-col justify-between ${small ? "p-4 pl-6" : "p-6 pl-8"} border border-cream/15`}>
            <div className="font-mono2 text-[9px] sm:text-[10px] tracking-[0.25em] uppercase text-cream/70">
              {category || "Ψηφιακή Έκδοση"}
            </div>
            <h3 className={`font-display ${small ? "text-lg" : "text-xl sm:text-2xl"} leading-snug font-semibold`}>{title}</h3>
            <div className="flex items-center justify-between font-mono2 text-[9px] sm:text-[10px] tracking-[0.2em] uppercase text-cream/60">
              <span>Noetica Lab</span>
              <span>{pages ? `${pages} σελ.` : "PDF"}</span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
